const headRowsEquip = {
  name: 'Tipo de Equipamento',
  equipmentGroup: 'Grupo',
  checklist: 'Checklist',
}

export default headRowsEquip;
